/**
 * @module app.kya.contracts.contractsCtrl
 *
 * The let names witch contain "loading" mean : is a request pending ?
 */
define(['angular', 'moment'], function(angular, moment) {

    function ContractsCtrl(
        $scope,
        $window,
        $location,
        $timeout,
        $log,
        $rootScope,
        Notification,
        $uibModal,
        agentService,
        editionService,
        contractService,
        eulerService,
        commonService,
        userService
    ) {
        let _agentService = agentService;
        let self = {};

        self.store = $rootScope.store;
        self.user = $rootScope.user;
        self.isExt = userService.isExternalUser($rootScope.user)
        self.isChanged = false;
        self.isUpdateLoading = false;
        self.isUpdateEuler = false;
        self.physicalPersons = ['Nom propre', 'EI', 'EIRL'];
        self.url = editionService.url;
        self.partnersFiltered = [];
        self.partners = [];
        self.civility = [
            { id: 1, label: 'Monsieur' },
            { id: 2, label: 'Madame' }
        ];
        self.contracts = [];

        self.goToList = function() {
            return $location.path('kya/list/');
        };

        self.maxDate = moment().format('YYYY-MM');

        if (!self.store) {
            self.goToList();
        }else {
            if(!self.store.headOfficeAddressStreet ||  self.store.headOfficeAddressStreet === ''){
                self.store.headOfficeAddressStreet =  self.store.addressStreet;
                self.store.headOfficeAddressPostalCode=  self.store.addressPostalCode;
                self.store.headOfficeAddressCity =  self.store.addressCity;
                self.isChanged = true;
            }
            if(self.store.agents !== undefined){
                self.store.agents.forEach(agent => {
                    switch (agent.civility) {
                        case '3':
                            agent.civility = '2';
                            break;
                        case '4':
                            agent.civility = '1';
                            break;
                    }
                    agent.isUpsAppUser = agent.phoneModelNumber !== null;
                });
            }
        }

        self.languageLevel = [
            {id: 'native', label: 'Maternelle'},
            {id: 'advanced', label: 'Avancé'},
            {id: 'intermediate', label: 'Intérmédiare'},
            {id: 'basic', label: 'Basique'}
        ];

        self.regulatorsBody = [
            {id: 'ACPR', label: 'ACPR'},
            {id: 'CBI', label: 'CBI'},
            {id: 'NBB', label: 'NBB'},
            {id: 'FCA', label: 'FCA'},
            {id: 'BOS', label: 'BOS'}
        ];

        /**
         * Get the contract's creator lastname and firstname to display
         * If the uid is not found into the people array, it returns the uid instead of the name
         * @param  {String} uid
         * @return {String}
         */
        self.getName = function(uid) {
            let people = userService.getPeopleList();
            for (let personIndex in people) {
                let person = people[personIndex].user;
                if (person.uid === uid) {
                    return commonService.getPersonFullName(person.firstname, person.lastname);
                }
            }
            if ($rootScope.user.uid === uid) {
                return commonService.getPersonFullName($rootScope.user.firstname, $rootScope.user.lastname);
            }
            return uid;
        };

        self.getContractStatus = function(contract) {
            if (!contract.isSend && !contract.isSigned && !contract.isCancelled) {
                return 'Non envoyé';
            }
            if (contract.isSend && !contract.isSigned && !contract.isCancelled) {
                return 'Envoyé';
            }
            if (!contract.isSigned && contract.isSend && !contract.isCancelled) {
                return 'Non Signé';
            }
            if (contract.isSigned && contract.isSend && !contract.isCancelled) {
                return 'Signé';
            }
            if (contract.isCancelled && contract.contractId === null) {
                return 'Annulé';
            }
            if (contract.isCancelled && contract.contractId !== null) {
                return 'Annulé / Remplacé';
            }
            if (contract.isJdsInjected && !contract.isCancelled) {
                return 'Injecté dans le JDS';
            }
        };

        self.getRisk = function() {
            if (self.store !== undefined) {
                self.isUpdateEuler = true;
                if (self.store.rcs && self.store.rcs !== ' ') {
                    return eulerService
                        .getRisk(self.store.rcs)
                        .then(risk => {
                            self.store.isCovered = !!(risk.length && risk[0].isCovered);
                        })
                        .catch(function(err) {
                            Notification.error(
                                'Impossible de déterminer le risque pour ce client</br>' + err.data.message
                            );
                            self.store.isCovered = 'error';
                            $log.error(err);
                        })
                        .finally(function() {
                            self.isUpdateEuler = false;
                        });
                }
                self.store.isCovered = 'error';
                Notification.error('RCS manquant.');
                self.isUpdateEuler = false;
            }
        };

        self.getServiceStatus = function(id) {
            for (const property in self.store.services) {
                if (self.store.services[property].service_id === id) {
                    return self.store.services[property].service_etat;
                }
            }
            return 'inactive';
        };

        self.getClassLabel = function() {
            let classLabel = 'badge-info';
            if (self.store !== undefined) {
                switch (self.store.storeActivity) {
                    case 'TABAC':
                        classLabel = 'badge-info';
                        break;
                    case 'PRESSE':
                        classLabel = 'badge-info';
                        break;
                    case 'TABAC PRESSE':
                        classLabel = 'badge-info';
                        break;
                    case 'BOULANGERIE':
                        classLabel = 'badge-warning';
                        break;
                    case 'FLEURISTE':
                        classLabel = 'badge-florajet';
                        break;
                    default:
                        classLabel = 'badge-info';
                }
            }
            return classLabel;
        };

        self.generatePdf = function(id) {
            if (self.isChanged) {
                Notification.error("Veuillez enregistrer les changements avant d'éditer les documents");
            }
            else {
                let test = _validatePartner(id);
                if (test.success) {
                    return editionService
                        .getDocumentsByPartner(id)
                        .then(function(documents) {
                            documents.forEach(doc => {
                                let contract = contractService.getContractObject();
                                let con = self.contracts.find(item => item.contractTypeId === doc.contractTypeId);
                                // console.log(con);
                                if (con !== undefined && !con.isCancelled) {
                                    contract = con;
                                }
                                else {
                                    contract.initiateBy = self.user.uid;
                                    contract.manager = self.user.parent.uid;
                                    contract.storeId = self.store.id;
                                    contract.contractTypeId = doc.contractTypeId;
                                }
                                // console.log(contract);
                                if (contract.isSigned && contract.contractId === null) {
                                    self.prepareCancelReplace(contract.id);
                                }
                                else {
                                    $window.open(
                                        editionService.url +
                                            'edition/template/' +
                                            self.store.id +
                                            '/' +
                                            doc.templateXsl,
                                        '_blank'
                                    );
                                    return contractService.createUpdate(contract).then(function(res) {
                                        if (res) {
                                            contract.id = res.contract_id;
                                            self.contracts.push(contract);
                                            Notification.success(
                                                "Le contrat est bien enregistré en base sous l'id : " + res.contract_id
                                            );
                                        }
                                    });
                                }
                            });
                            _getContracts();
                        })
                        .catch(function(err) {
                            $log.error(err);
                            Notification.error('Une erreur est survenue : ' + err.data);
                        });
                }
                else {
                    Notification.error(test.error);
                }
            }
        };

        self.copyHours = function() {
            self.isChanged = true;
            for(let i=1; i < self.store.horaires.length; i++) {
                self.store.horaires[i].morningOpen = self.store.horaires[0].morningOpen;
                self.store.horaires[i].morningClose = self.store.horaires[0].morningClose;
                self.store.horaires[i].afternoonOpen = self.store.horaires[0].afternoonOpen;
                self.store.horaires[i].afternoonClose = self.store.horaires[0].afternoonClose;
            }
        };

        function _validatePartner(id) {
            let result = {};
            let success = true;
            let partner = self.partners.filter(part => part.id === id); console.log(partner[0])
            let msg =
                'Vous devez compléter ces champs avant de pouvoir éditer les document de : ' +
                partner[0].label +
                '<br/><ul>';
            switch (partner[0].code) {
                case 'THE':
                    if (!self.store.headOfficeAddressStreet || !self.store.headOfficeAddressPostalCode || !self.store.headOfficeAddressCity) {
                    msg += '<li>Adresse du siège</li>';
                    success = false;
                    }
                    break;
                case 'VCS':
                    self.store.agents.forEach(agent => {
                        if (agent.active) {
                            if (agent.isLegalRepresentative) {
                                if (!agent.birthDate) {
                                    msg += '<li>Date de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthPostalCode) {
                                    msg +=
                                        '<li>Code postal naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthCity) {
                                    msg += '<li>Ville de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthCountry) {
                                    msg += '<li>Pays de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.termStart) {
                                    msg += '<li>Début mandat ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                            if (agent.formation) {
                                if (!agent.email) {
                                    msg += '<li>Email ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                        }
                    });
                    if ((self.store.shareCapital === '' || self.store.shareCapital === 0 || self.store.shareCapital === null) && !self.store.physicalPerson) {
                        msg += '<li>Capital social</li>';
                        success = false;
                    }
                    break;
                case 'soFormationEN':
                case 'soFormationPDVFull':
                case 'soFormationPDVLight':
                    self.store.agents.forEach(agent => {
                        if (agent.active) {
                            if (agent.ocFormation) {
                                if (!agent.socialSecurityNumber) {
                                    msg +=
                                        '<li>N° de sécurité social ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthDate) {
                                    msg += '<li>Date de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (agent.civility === '2') {
                                    if (!agent.maidenName) {
                                        msg +=
                                            '<li>Nom de jeune fille ' +
                                            agent.firstName +
                                            ' ' +
                                            agent.lastName +
                                            '</li>';
                                        success = false;
                                    }
                                }
                                if (agent.isRfcAgent) {
                                    if (!agent.diploma) {
                                        msg +=
                                            '<li>Niveau dernier diplôme ' +
                                            agent.firstName +
                                            ' ' +
                                            agent.lastName +
                                            '</li>';
                                        success = false;
                                    }
                                    if (!agent.termStart) {
                                        msg += '<li>Début mandat ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                }
                                if (!agent.email) {
                                    msg += '<li>Email ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                        }
                    });
                    if (!self.store.accountingPhone) {
                        msg += '<li>Téléphone du comptable</li>';
                        success = false;
                    }
                    if (!self.store.apeCode) {
                        msg += '<li>Code APE (NAF)</li>';
                        success = false;
                    }
                    if (!self.store.emblem) {
                        msg += '<li>Enseigne</li>';
                        success = false;
                    }
                    break;
                case 'PCS':
                    if ((self.store.shareCapital === '' || self.store.shareCapital === 0 || self.store.shareCapital === null) && !self.store.physicalPerson) {
                        msg += '<li>Capital social</li>';
                        success = false;
                    }
                    if (!self.store.headOfficeAddressStreet || !self.store.headOfficeAddressPostalCode || !self.store.headOfficeAddressCity) {
                        msg += '<li>Adresse du siège</li>';
                        success = false;
                    }
                    self.store.agents.forEach(agent => {
                        if (agent.active) {
                            if (agent.formation) {
                                if (!agent.email) {
                                    msg += '<li>Email ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                        }
                    });
                    break;
                case 'OMF':
                    self.store.agents.forEach(agent => {
                        if (agent.active) {
                            if (agent.isLegalRepresentative) {
                                if (!agent.birthDate) {
                                    msg += '<li>Date de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthCity) {
                                    msg += '<li>Ville de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthCountry) {
                                    msg += '<li>Pays de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                            if (agent.formation) {
                                if (!agent.email || agent.email == '') {
                                    msg += '<li>Email ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                        }
                    });
                    if ((self.store.shareCapital === '' || self.store.shareCapital === 0 || self.store.shareCapital === null) && !self.store.physicalPerson) {
                        msg += '<li>Capital social</li>';
                        success = false;
                    }
                    break;
                case 'DLB':
                    self.store.agents.forEach(agent => {
                        if (agent.active) {
                            if (agent.isLegalRepresentative) {
                                if (!agent.birthDate) {
                                    msg += '<li>Date de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthPostalCode) {
                                    msg +=
                                        '<li>Code postal naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthCity) {
                                    msg += '<li>Ville de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if (!agent.birthCountry) {
                                    msg += '<li>Pays de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                            if (agent.formation) {
                                if (!agent.email || agent.email == '') {
                                    msg += '<li>Email ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                        }
                    });
                    if ((self.store.shareCapital === '' || self.store.shareCapital === 0 || self.store.shareCapital === null) && !self.store.physicalPerson) {
                        msg += '<li>Capital social</li>';
                        success = false;
                    }
                    break;
                case 'UPS':
                    if (!self.store.numberPackages) {
                        msg += '<li>Nombre de colis</li>';
                        success = false;
                    }
                    if (
                        (self.store.isUpsAccessScanup === '1' || self.store.isUpsAccessScanup === '2') &&
                        self.store.typeScanup === null
                    ) {
                        msg += "<li>Type de Scan'up</li>";
                        success = false;
                    }
                    let isOk = false;
                    self.store.agents.forEach(agent => {
                        if (
                            (self.store.isUpsAccessScanup === '0' || self.store.isUpsAccessScanup === '2') &&
                            agent.active
                        ) {
                            if (agent.isUpsAppUser) {
                                isOk = true;
                                if (!agent.phoneModelNumber || agent.phoneModelNumber === ' ') {
                                    msg +=
                                        '<li>Num. modèle téléphone ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                            }
                        }
                    });
                    if (!isOk && (self.store.isUpsAccessScanup === '0' || self.store.isUpsAccessScanup === '2')) {
                        msg += '<li>Au moins 1 personne doit à avoir un modèle de téléphone</li>';
                        success = false;
                    }
                    break;
                case 'RIA':
                    self.store.agents.forEach(agent => {
                        if (agent.active) {
                            if (!agent.email || agent.email == '') {
                                msg += '<li>Email ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                success = false;
                            }
                        }
                    });
                    break;
                case 'WU':
                    if (!self.store.phoneNumber) {
                        msg += '<li>Téléphone fixe du point de vente</li>';
                        success = false;
                    }
                    self.store.agents.forEach(agent => {
                        if (partner[0].label === 'Western Union : précheck' && agent.active) {
                            if (!agent.email || agent.email == '') {
                                msg += '<li>Email ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                success = false;
                            }
                        }
                        if(agent.active && agent.isLegalRepresentative && (agent.shareCapital === null || agent.shareCapital === '' )) {
                            msg += '<li>Le % de capital pour ' + agent.firstName + ' ' + agent.lastName + '</li>';
                            success = false;
                        }
                    });
                    break;
                case 'WAF':
                    if (!self.store.headOfficeAddressStreet || !self.store.headOfficeAddressPostalCode || !self.store.headOfficeAddressCity) {
                        msg += '<li>Adresse du siège</li>';
                        success = false;
                    }
                    self.store.agents.forEach(agent => {
                        if (agent.active) {
                            if (agent.isLegalRepresentative) {
                                if(!agent.birthDate){
                                    msg +=
                                        '<li>Date anniversaire ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if(!agent.birthCountry){
                                    msg +=
                                        '<li>Pays de naissance ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if(!agent.isNationalId && !agent.isResidencePermit && !agent.isPassport){
                                    msg +=
                                        '<li>Au moins un type de pièce d\'identité ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                    success = false;
                                }
                                if(agent.isNationalId){
                                    if(!agent.nationalIdNumber){
                                        msg +=
                                            '<li>Numéro de carte d\'identité ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                    if(!agent.nationalIdCountry){
                                        msg +=
                                            '<li>Pays de délivrance de carte d\'identité ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                    if(!agent.nationalIdExpiration){
                                        msg +=
                                            '<li>Date expiration carte d\'identité ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                }
                                if(agent.isResidencePermit){
                                    if(!agent.residencePermitNumber){
                                        msg +=
                                            '<li>Numéro de titre de séjour ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                    if(!agent.residencePermitCountry){
                                        msg +=
                                            '<li>Pays de délivrance du titre de séjour ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                    if(!agent.residencePermitExpiration){
                                        msg +=
                                            '<li>Date expiration titre de séjour ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                }
                                if(agent.isPassport){
                                    if(!agent.passportNumber){
                                        msg +=
                                            '<li>Numéro de passeport ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                    if(!agent.passportCountry){
                                        msg +=
                                            '<li>Pays de délivrance du passeport ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                    if(!agent.passportExpiration){
                                        msg +=
                                            '<li>Date expiration passeport ' + agent.firstName + ' ' + agent.lastName + '</li>';
                                        success = false;
                                    }
                                }
                            }
                        }
                    });
                    break;
                case 'AML':
                    let aml = [];
                    let employee = [];
                    self.store.agents.forEach(agent => {
                        // if(agent.active && !agent.isCashIn && ['gérant', 'gérant-associé','président', 'directeur'].includes(agent.quality)){
                        //     msg += '<li>Agent ' + agent.firstName + ' ' + agent.lastName + '  : doit participer à la formation AML sur les services de Cash-In</li>';
                        //     success = false;
                        //
                        // }
                       if(agent.formation && agent.active && !agent.isMoneyTransfer && !agent.isCashIn){
                           msg += '<li>Agent ' + agent.firstName + ' ' + agent.lastName + '  : doit participer à la formation AML mais n\'a aucun service de sélectionner</li>';
                           success = false;
                       }
                        if ((!agent.email || agent.email == '') && agent.active && agent.formation) {
                            msg += '<li>Email ' + agent.firstName + ' ' + agent.lastName + '</li>';
                            success = false;
                        }
                       if(agent.quality === 'employee' && agent.active){
                           employee.push(agent);
                           if(!agent.formation)
                               aml.push(agent);
                       }
                    });
                    // if(self.store.isEmployee){
                    //     if((employee.length > 0 && aml.length === employee.length) || employee.length === 0){
                    //         msg += '<li>Aucun collaborateur ne participe à la formation AML, alors que vous indiquez le contraire.</li>';
                    //         success = false;
                    //     }
                    //
                    // }
                    break;
            }
            msg += '</ul>';
            result.success = success;
            result.error = msg;
            return result;
        }

        self.changedIsEmployee = function() {
            self.isChanged = true;
            self.store.isEmployee = !!self.store.isEmployee;
            if(!self.store.isEmployee){
                self.store.isMoneyTransfer = false;
                self.store.isCashIn = false;
                self.store.agents.map(agent => {
                    if(agent.quality === 'employee') {
                        agent.formation = false;
                        agent.isMoneyTransfer = false;
                        agent.isCashIn = false;
                    }

                });
            }
        }

        self.changedIsCashIn = function() {
            self.isChanged = true;
            self.store.isCashIn = !!self.store.isCashIn;
            if(!self.store.isCashIn){
                self.store.agents.map(agent => {
                    if(agent.quality === 'employee') {
                        agent.isCashIn = false;
                    }

                });
            }
        }

        self.changedIsMoneyTransfer = function() {
            self.isChanged = true;
            self.store.isMoneyTransfer = !!self.store.isMoneyTransfer;
            if(!self.store.isMoneyTransfer){
                self.store.agents.map(agent => {
                    if(agent.quality === 'employee') {
                        agent.isMoneyTransfer = false;
                    }

                });
            }
        }

        self.isChangedCashIn = function(ag) {
            self.isChanged = true;
            self.store.agents.map(agent => {
                if(agent.active && agent.isLegalRepresentative && agent.formation)
                    agent.isCashIn = ag.isCashIn;
            });
        }

        self.changedLegalForm = function() {
            self.isChanged = true;
            self.store.physicalPerson = self.physicalPersons.indexOf(self.store.legalForm) !== -1;
            self.store.agents.map(agent => {
                if(agent.active && agent.isLegalRepresentative && ['associé','conjoint','employee'].indexOf(agent.quality) === -1) {
                    agent.principalContact = true;
                    agent.complianceDelegate = true;
                    agent.operator = true;
                    agent.authorizedSignatory = true;
                    agent.isDecisionMaker = true;
                }
            });
        };
        // [{id: '0', label: 'Téléphone'}, {id: '1', label: 'Scan\'up'}, {id: '2', label: 'Scan\'up & Téléphone'}]
        self.changedIsUpsAccessScanup = function() {
            self.isChanged = true;
            self.store.typeScanup =
                self.store.isUpsAccessScanup === '1' || self.store.isUpsAccessScanup === '2'
                    ? self.store.typeScanup
                    : null;
            if (self.store.isUpsAccessScanup === '1') {
                self.store.agents.map(agent => {
                    agent.isUpsAppUser = false;
                    agent.phoneModelNumber = null;
                });
            }
        };
        self.changedIsUpsAppUser = function(agent) {
            self.isChanged = true;
            agent.phoneModelNumber = !agent.isUpsAppUser ? null : agent.phoneModelNumber;
        };

        self.changedCertificate = function(agent){
            self.isChanged = true;
            agent.otherCertificate = agent.certificate === 'other' ? agent.otherCertificate : null;
        }

        self.changedBusinessType = function(store){
            self.isChanged = true;
            store.otherBusinessType = store.businessType === 'autre' ? store.otherBusinessType : null;
        }

        self.changedFinancialSector = (agent) => {
            self.isChanged = true;
            agent.financialSectorDescription = agent.isFinancialSector ? agent.financialSectorDescription : null;
        }
        self.changeRegulatorBody = (agent, index, label) => {
            self.isChanged = true;
            angular.forEach(agent.regulators, (reg, i) => {
                console.log(i)
                if(reg.name === label && index !== i){
                    agent.regulators[index].name = null
                    Notification.error('Vous avez déjà sélectionné cet organisme');
                }
            }, []);
        }

        self.changedAML = function(agent) {
            console.log(agent);
            agent.isCashIn = false;
            agent.isMoneyTransfer = false;
            self.isChanged = true;
        }

        self.initDate = function(store, isChanged) {
            if (store !== undefined) {
                if (isChanged) {
                    self.isChanged = true;
                }
                store.agents.forEach(agent => {
                    agent.birthDate = agent.birthDate
                        ? new Date(
                            moment(agent.birthDate)
                                .format('YYYY-MM-DD')
                        )
                        : null;
                    agent.termStart = agent.termStart
                        ? new Date(
                            moment(agent.termStart)
                                .format('YYYY-MM-DD')
                        )
                        : null;
                    agent.nationalIdExpiration = agent.nationalIdExpiration
                        ? new Date(
                            moment(agent.nationalIdExpiration).format('YYYY-MM-DD')
                        )
                        : null;
                    agent.residencePermitExpiration = agent.residencePermitExpiration
                        ? new Date(
                            moment(agent.residencePermitExpiration).format('YYYY-MM-DD')
                        )
                        : null;
                    agent.passportExpiration = agent.passportExpiration
                        ? new Date(
                            moment(agent.passportExpiration).format('YYYY-MM-DD')
                        )
                        : null;
                    agent.experiences.forEach((exp)=>{
                        exp.startingDate = exp.startingDate
                            ? new Date(
                                exp.startingDate
                            )
                            :null
                        exp.endDate = exp.endDate
                            ? new Date(
                                exp.endDate
                            )
                            :null
                    });
                    agent.regulators.forEach(reg => {
                        reg.startingDate = reg.startingDate
                            ? new Date(
                                reg.startingDate
                            )
                            :null
                        reg.endDate = reg.endDate
                            ? new Date(
                                reg.endDate
                            )
                            :null
                    });
                });

                store.dateRcs = self.store.dateRcs
                    ? new Date(
                        moment(self.store.dateRcs)
                            .format('YYYY-MM-DD')
                    )
                    : null;
            }
        };
        self.initDate(self.store, false);

        self.initHours = function(store, isChanged){
            if(store !== undefined){
                if(isChanged){
                    self.isChanged = true;
                }
                const keys = ['morningOpen', 'morningClose', 'afternoonOpen', 'afternoonClose'];
                store.horaires.forEach(day => {
                    for(let i = 0; i < keys.length ; i++){
                        day[keys[i]] = day[keys[i]]
                            ? new Date(
                                moment(day[keys[i]])
                                    .format('YYYY-MM-DD HH:mm')
                            )
                            : null;
                    }
                });
            }
        }
        self.initHours(self.store, false);

        /**
         *
         * @param {object} agent
         * @returns boolean
         */
        self.isLegalRepresentative = function(agent) {
            return agent.isLegalRepresentative;
        };

        /**
         *
         * @param {object} agent
         * @returns boolean
         */
        self.isRfcAgent = function(agent) {
            return agent.isRfcAgent;
        };

        self.addLegalRepresentative = function() {
            let newAgent = _agentService.getAgentObject();
            newAgent.isLegalRepresentative = true;
            newAgent.quality = 'délégué';
            self.store.agents.push(newAgent);
            $log.info('store', self.store);
        };

        self.addEmployee = function() {
            let newAgent = _agentService.getAgentObject();
            newAgent.quality = 'employee';
            newAgent.formation = true;
            self.store.agents.push(newAgent);
            $log.info('store', self.store);
        };

        self.addExperience = function(agent){
            let experience = {
                agentId : agent.id,
                companyName: null,
                position: null,
                description: null,
                startingDate: null,
                endDate: null
            }
            agent.experiences.push(experience);
        }

        self.delExperience = function(agent, index){
            _agentService.deleteExperience(agent.experiences[index].id).then(function(res){
                agent.experiences.splice(index, 1);
                Notification.success('Expérience supprimée');
            });
        }

        self.addRegulators = function(agent){
            let regulatorBody = {
                agentId : agent.id,
                name: null,
                startingDate: null,
                endDate: null
            }
            agent.regulators.push(regulatorBody);
        }

        self.delRegulator = function (agent, index){
            self.isChanged = true;
            agent.regulators.splice(index, 1);
            if(agent.regulators.length === 0){
                agent.isLicensedByRegulatorBody = false;
            }
        }

        self.importRegulators = function (agent){
            agent.regulators = self.store.agents[0].regulators;
        }

        self.copyAddress = function(agent) {
            if (agent.isRfcAgent) {
                agent.addressCountry = self.store.addressCountry;
                agent.addressStreet = self.store.addressStreet;
                agent.addressPostalCode = self.store.addressPostalCode;
                agent.addressCity = self.store.addressCity;
            }
            else {
                agent.addressCountry = self.store.agents[0].addressCountry;
                agent.addressStreet = self.store.agents[0].addressStreet;
                agent.addressPostalCode = self.store.agents[0].addressPostalCode;
                agent.addressCity = self.store.agents[0].addressCity;
            }
            $log.info('store', self.store);
        };

        self.copyStoreAddress = function(){
            self.store.headOfficeAddressStreet = self.store.addressStreet;
            self.store.headOfficeAddressPostalCode = self.store.addressPostalCode;
            self.store.headOfficeAddressCity = self.store.addressCity;
        }

        function _nbAgents() {
            let nombre = {};
            let leg = 0;
            let emp = 0;
            if (self.store !== undefined) {
                for (let i = 0; i < self.store.agents.length; i++) {
                    if (self.store.agents[i].isLegalRepresentative) {
                        leg++;
                    }
                    else {
                        emp++;
                    }
                }
                nombre.legalRepresentative = leg;
                nombre.employee = emp;
            }
            return nombre;
        }

        self.isPluralLegalRepresentative = function() {
            let nbAgent = _nbAgents();
            return nbAgent.legalRepresentative > 1;
        };

        self.isPluralEmployee = function() {
            let nbAgent = _nbAgents();
            return nbAgent.employee > 1;
        };

        self.isOneOrMoreEmployee = function() {
            let nbAgent = _nbAgents();
            return nbAgent.employee > 0;
        };

        self.isUniqueEmail = function() {
            if (self.store !== undefined) {
                let emails = self.store.agents.map(agent => agent.email).filter(Boolean);
                return (
                    emails.length ===
                    emails.filter((agent, index) => emails.indexOf(agent) === index).filter(Boolean).length
                );
            }
            return false;
        };

        function _isExperienceOk(){
            let isOk = true;
            self.store.agents.forEach(agent => {
                if (agent.experiences.length !== 0){
                    agent.experiences.forEach(exp => {
                        if (exp.startingDate === null){
                            isOk = false;
                        }
                    })
                }
            });
            return isOk;
        }

        function _isFormationOk() {
            let isOk = false;
            self.store.agents.forEach(agent => {
                if (agent.formation === true && agent.isLegalRepresentative === true) {
                    isOk = true;
                }
            });
            return isOk;
        }

        function _isQuality() {
            let isQuality = true;
            self.store.agents.forEach(agent => {
                if (agent.quality === null && agent.isLegalRepresentative === true) {
                    isQuality = false;
                }
            });
            return isQuality;
        }

        self.isActive = function(agent) {
            return agent.active;
        };

        self.delAgent = function(agent) {
            if (agent.id === null) {
                let index = self.store.agents.indexOf(agent);
                self.store.agents.splice(index, 1);
            }
            else {
                agent.active = !agent.active;
                self.isChanged = true;
            }
            $log.info('store', self.store);
        };


        self.createUpdateAgent = function() {
            self.isUpdateLoading = true;
            self.initHours(self.store, false);
            if (self.isUniqueEmail() && _isFormationOk() && _isQuality() && _isExperienceOk()) {
                _agentService
                    .createUpdate(self.store)
                    .then(function(res) {
                        if (res[0].id) {
                            self.store = res[0];
                            self.initDate(self.store, false);
                            self.initHours(self.store, false);
                            Notification.success("L'agent a bien été mis à jour");
                            $log.info('store', self.store);
                        }
                    })
                    .catch(function(err) {
                        $log.error(err);
                        Notification.error('Une erreur est survenue : ' + err.data);
                    })
                    .finally(function() {
                        self.isUpdateLoading = false;
                        self.isChanged = false;
                    });
            }
            else {
                let msg = 'Une erreur est survenue :<br/> <ul>';
                if (!self.isUniqueEmail()) {
                    msg += "<li>L'adresse email doit être unique</li>";
                }
                if (!_isFormationOk()) {
                    msg += '<li>Au moins un des représentants légaux doit participer à la formation AML</li>';
                }
                if (!_isQuality()) {
                    msg += '<li>Vous devez sélectionner une qualité pour les représentants légaux</li>';
                }
                if (!_isExperienceOk())
                    msg += '<li>Il manque une date de début à une expérience professionnelle</li>';
                msg += '</ul>';
                Notification.error(msg);
                self.isUpdateLoading = false;
            }
        };

        function _getContracts() {
            if (self.store !== undefined && self.store.id) {
                return contractService.getContractsByStore(self.store.id).then(contracts => {
                    // console.log(contracts);
                    self.contracts = contracts.reduce((unique, item, index) => {
                        if (unique) {
                            if (unique.find(ct => ct.contractTypeId === item.contractTypeId)) {
                                return unique;
                            }
                            return [...unique, item];
                        }
                    }, []);
                });
            }
        }

        function _getPartners() {
            return editionService.getAllPartners('kya').then(res => {
                self.partners = res;
            });
        }

        _getPartners();
        _getContracts();
        self.getRisk();
        $log.info('store', self.store);




        $scope.$on('$locationChangeStart', function(event, next, current) {
            if (self.isChanged && self.store.id && !self.isExt && /contracts/.test(current)) {
                self.createUpdateAgent();
            }
        });

        /* =========================================================================================== */
        /*                                         MODALS                                              */
        /* =========================================================================================== */

        /**
         * Prepare the contract to cancel
         * @param  {int} id
         */
        self.prepareCancelReplace = function(id) {
            self.contractToCancelReplace = id;
            _openModalCancelReplaceContract();
        };

        /**
         *
         * Cancel the prepared contract
         * @param  {Object} data object coming from sendContract modal
         */
        function _confirmCancelReplace(data) {
            for (let i = 0; i < self.contracts.length; i++) {
                if (self.contracts[i].id === self.contractToCancelReplace) {
                    self.contracts[i].dateCancellation = new Date(moment().format('YYYY-MM-DD'));
                    self.contracts[i].isCancelled = 1;
                    self.contracts[i].initiateBy = self.user.uid;
                    self.contracts[i].manager = self.user.parent.uid;
                    contractService
                        .cancelReplaceContract(self.contracts[i])
                        .then(function(info) {
                            Notification.success(info);
                        })
                        .catch(function(err) {
                            Notification.error('Une erreur est survenue: ' + err.data);
                            $log.error(err);
                        });
                    break;
                }
            }
        }

        /**
         * Open the cancel modal
         */
        function _openModalCancelReplaceContract(contract) {
            let _cancelReplaceContractModal = $uibModal.open({
                animation: true,
                templateUrl: 'cancelReplaceContractModal.html',
                controller: 'CancelReplaceContractCtrl',
                controllerAs: 'cancelReplaceContractCtrl',
                size: null,
                resolve: {
                    contract: function() {
                        return contract;
                    }
                }
            });

            _cancelReplaceContractModal.result.then(function(data) {
                _confirmCancelReplace(data);
            });
        }

        return self;
    }

    ContractsCtrl.$inject = [
        '$scope',
        '$window',
        '$location',
        '$timeout',
        '$log',
        '$rootScope',
        'Notification',
        '$uibModal',
        'agentService',
        'editionService',
        'contractService',
        'eulerService',
        'commonService',
        'userService'
    ];

    angular
        .module('app.kya.contracts.contractsCtrl', ['ui.bootstrap', 'ui-notification'])
        .controller('ContractsCtrl', ContractsCtrl)
        .config([
            'NotificationProvider',
            function(NotificationProvider) {
                NotificationProvider.setOptions({
                    delay: 10000,
                    startTop: 60,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'center',
                    positionY: 'top'
                });
            }
        ]);
});
